export enum TabsType {
  All = 'all',
  Selected = 'selected',
}

export enum Ordering {
  Default = 'default',
  AtoZ = 'a-z',
  ZtoA = 'z-a',
}
